<template>
    <div>
        <div v-if="loading" class="page-loading-container">
            <b-spinner label="Loading..."></b-spinner>
        </div>
        <div v-else>
            <div class="float-right" id="top">
                <b-pagination-nav
                        v-model="currentPage"
                        :link-gen="linkGen()"
                        use-router
                        :number-of-pages="numberOfPages"
                        base-url="#"
                        first-number
                        last-number
                        align="right"
                ></b-pagination-nav>
            </div>
            <h1 class="page-title">
                SEO content issues
            </h1>
            <b-alert
                    v-if="!scanStatus.completed"
                    show
                    variant="primary"
            ><b-spinner
                    label="Loading..."
                    style="width:16px;height:16px"
            ></b-spinner>
                Check in progress.<br />
                Results will show up here automatically</b-alert
            >
            <b-alert
                    v-if="scanStatus.completed && pages.length === 0"
                    show
                    variant="success"
            ><span
                    class="glyphicon glyphicon-thumbs-up"
                    style="font-size:16px"
            ></span>
                No Issues found.</b-alert
            >
            <b-row v-for="page in pages">
                <b-col md="4" lg="4" sm="4" xs="5" style="">
                    <div style="position:relative;white-space:nowrap;z-index:99">
              <span
                      class="circle bg-warning text-success mr-xs"
                      style="font-size: 8px;line-height:15px"
              >.</span
              >
                        <a :href="page.url" target="_blank" title="External Link"><b>{{ page.url }}</b></a>
                    </div>
                    <div style="position:absolute;top:10px">
                        <div class="mr-lg d-flex align-items-center">
                            <img
                                    v-if="deviceDetails.mockup.image"
                                    :src="`/${deviceDetails.mockup.image}.png`"
                                    :width="deviceDetails.mockup.size.width"
                                    :style="
                    `position:absolute;top:${
                      deviceDetails.mockup.size.top
                    }px;left:${deviceDetails.mockup.size.left}px`
                  "
                                    class="desktop-preview"
                            />

                            <div
                                    :style="
                    `position:absolute;left:${
                      deviceDetails.mockup.inner_size.left
                    }px;top:${
                      deviceDetails.mockup.inner_size.top
                    }px;border-radius:2px`
                  "
                            >
                                <vue-load-image
                                        v-if="page.layoutErrors && page.layoutErrors[0]"
                                >
                                    <img
                                            slot="image"
                                            :src="
                        `${page.layoutErrors[page.selectedLayoutIndex].img}`
                      "
                                    />
                                    <div
                                            slot="preloader"
                                            class="image-loading-container"
                                            style="width:126px;height:277px;position:absolute;left:21px;top:20px;border-radius:4px"
                                    >
                                        <div><b-spinner label="Loading..."></b-spinner></div>
                                    </div>
                                    <div slot="error" class="screenshot-error" :style="{width: deviceDetails.mockup.inner_size.width+'px', 'background-color': 'unset', border: 'unset'}">
                                        <p></p>
                                        <h4>Cannot Load Image.</h4>
                                        <p>
                                            If this problem persists please let us know.
                                        </p>
                                        <i class="fa fa-warning"></i>
                                    </div>
                                </vue-load-image>

                                <div
                                        class="errorbox"
                                        :style="
                      `position:absolute;z-index:99;
            top:${page.layoutErrors[page.selectedLayoutIndex].errorBox.top}px;
            left:${page.layoutErrors[page.selectedLayoutIndex].errorBox.left}px;
            width:${
              page.layoutErrors[page.selectedLayoutIndex].errorBox.width
            }px;height:${
                        page.layoutErrors[page.selectedLayoutIndex].errorBox
                          .height
                      }px;
            border:2px dashed red`
                    "
                                >
                                    <div
                                            style="background-color:red;opacity:0.2;;width:100%;height:100%"
                                    ></div>
                                </div>
                            </div>
                        </div>
                        &nbsp;
                    </div>
                </b-col>
                <b-col
                >&nbsp;
                    <div class="pb-xlg h-100" :style="`min-height:${minHeight}px`">
                        <Widget class="h-100 mb-0" :title="page.title">
                            <p class="text-muted">
                                <small class="mr-lg d-flex align-items-center">Last checked {{page.crawl_date | moment('from')}}</small>

                                <small>
                                    <router-link :to="{ name: 'ExplorePageDetails', query: {url: page.path} }"  v-b-tooltip.hover title="Page Details"><i class="fa fa-eye"></i> Page Details</router-link>
                                </small>
                            </p>
                            <p>
                                <b>Image elements do not have [alt] attributes:</b>
                            </p>
                            <div v-for="(layoutError, i) in page.layoutErrors"  @mouseover="mouseOver(page, i)" :class="{layoutError: true, layoutErrorActive: i === page.selectedLayoutIndex}">
                                <small
                                        class="mr-lg d-flex align-items-center"

                                >
                    <span
                            class="circle bg-warning text-warning mr-xs"
                            style="font-size: 8px;"
                    >.</span
                    >
                                    <div class="errorMessage">{{ layoutError.message }}</div>
                                    <img :src="layoutError.preview">
                                    <br>
                                </small>
                            </div>
                        </Widget>
                    </div>
                </b-col>

                &nbsp;
            </b-row>
            <div class="float-right">
                <b-pagination-nav
                        v-model="currentPage"
                        :link-gen="linkGen('#top')"
                        use-router
                        :number-of-pages="numberOfPages"
                        base-url="#"
                        first-number
                        last-number
                        align="right"
                ></b-pagination-nav>
            </div>
        </div>

    </div>
</template>

<script>
  import axios from "axios";
  import { ApolloClient } from "apollo-client";
  import { mapState } from 'vuex';
  import gql from "graphql-tag";
  import Widget from '@/components/Widget/Widget';
  import VueLoadImage from "vue-load-image";
  export default {
    name: 'Subscriptions',
    components: { Widget, "vue-load-image": VueLoadImage  },
    data(){
      return {
        device: 'galaxy_s6',
        loading: true,
        crawlVersion: 0,
        currentPage: 1,
        numberOfPages: 1,
        deviceDetails: null,
        pageCount: 1,
        pageSize: 5,
        pages: [],
      }
    },
    apollo: {
      deviceQuery: {
        query() {
          return gql`query {
          deviceQuery:websites_device(where: {id: {_eq: "${this.device}"}}){
            name
            platform
            id
            viewport
            mockup
          }
         }`;
        },
        result(a, b) {
          this.deviceDetails = a.data.deviceQuery[0];
          this.minHeight = Math.round(
            (this.deviceDetails.mockup.inner_size.width *
              this.deviceDetails.viewport.height) /
            this.deviceDetails.viewport.width
          );
          this.minHeight += this.deviceDetails.mockup.inner_size.top * 2;
        }
      },
      $subscribe: {
        websites_website: {
          query() {
            return gql`subscription {
            websites_website(where: {id: {_eq: ${this.activeSite.id}}}) {
              id
              url
              active_crawl {
                id
                status
                websites_crawledpages(where: {websites_devicerenders: {device_id: {_eq: "${this.device}"}}, ready: {_eq: true}},
                limit: ${this.pageSize}, offset: ${(this.currentPage - 1) * this.pageSize || 0}, order_by: {level: asc, id: asc}) {
                  title
                  crawl_date
                  level
                  url
                  path
                  websites_devicerenders(where: {device_id: {_eq: "${this.device}"}}){
                    device_id
                    screenshots
                    layout_errors
                    render_data
                    websites_lighthousereport{
                      ready
                      seo
                      performance
                      best_practices
                      accessibility
                      issues_seo_image_alt
                    }
                  }
                }
                websites_crawledpages_aggregate(where: {ready: {_eq: true}, websites_devicerenders: {device_id: {_eq: "${this.device}"}}}){
                  aggregate {
                    count
                  }
                }
              }
            }
          }`;
          },
          skip () {
            return !(this.deviceDetails && this.activeSite.id);
          },
          result (data) {
            this.loading = true;
            this.pageCount = 0;
            this.numberOfPages = 1;
            this.pages = [];
            if (data.data.websites_website && data.data.websites_website.length) {
              this.homePage = data.data.websites_website;
              let activeCrawl = data.data.websites_website[0].active_crawl;
              if (activeCrawl) {
                this.homePage.pageCount =
                  data.data.websites_website[0].active_crawl.websites_crawledpages_aggregate.aggregate.count;
                if (this.homePage.pageCount) {
                  this.pageCount = this.homePage.pageCount;
                  this.numberOfPages = Math.ceil(this.pageCount / this.pageSize);
                  if (this.currentPage > this.numberOfPages) {
                    this.$router.push({name: "ExplorePage"});
                  }

                  this.pages =
                    data.data.websites_website[0].active_crawl.websites_crawledpages;
                }

                let wantedWidth = this.deviceDetails.mockup.inner_size.width;
                let ratio = wantedWidth / this.deviceDetails.viewport.width;

                let wantedHeight = Math.round(
                  this.deviceDetails.viewport.height * ratio
                );

                let realPages = [];
                for (let page of this.pages) {
                  page.layoutIndex = 0;
                  this.$set(page, "selectedLayoutIndex", 0);
                  page.layoutErrors = [];
                  // page.selectedLayoutIndex = 0;
                  let render = page.websites_devicerenders[0];

                  if (!render.websites_lighthousereport.issues_seo_image_alt.length > 0){
                    continue
                  }
                  realPages.push(page);


                  let initialScale =
                    this.deviceDetails.viewport.width /
                    render.render_data.clientWidth;

                  let renderMaxRatio =
                    wantedWidth / render.screenshots["full"].screenshot.width;

                  let padding = 0;

                  page.device = render.device_id;

                  for (let layoutError of render.websites_lighthousereport.issues_seo_image_alt) {

                    if (!layoutError.box){
                      continue;
                    }

                    layoutError.box.y *= initialScale;
                    layoutError.box.x *= initialScale;
                    layoutError.box.width *= initialScale;
                    layoutError.box.height *= initialScale;

                    if (layoutError.reason !== 'horizontal_scrolling') {
                      layoutError.box.y -= padding / 2;
                      layoutError.box.height += padding;
                      layoutError.box.x -= padding / 2;
                      layoutError.box.width += padding;
                    }

                    let y = Math.round(
                      (layoutError.box.y +
                        layoutError.box.height / 2 -
                        this.deviceDetails.viewport.height / 2) *
                      ratio
                    );
                    let wantedY = y;
                    y = Math.max(0, y);

                    y = Math.min(
                      y,
                      Math.round(
                        render.screenshots["full"].screenshot.height *
                        renderMaxRatio -
                        wantedHeight
                      )
                    );
                    let tr = `w-${wantedWidth},:w-${wantedWidth},h-${wantedHeight},cm-extract,x-0,y-${y}`;
                    let tr_preview = `w-${this.deviceDetails.viewport.width},:cm-extract,x-${Math.round(layoutError.box.x)},y-${Math.round(layoutError.box.y)},w-${Math.round(layoutError.box.width)},h-${Math.round(layoutError.box.height)}:cm-pad_resize,w-50`;

                    let errorBox = {
                      top: Math.max(0, Math.round(
                        (this.deviceDetails.viewport.height / 2 -
                          layoutError.box.height / 2) *
                        ratio +
                        wantedY -
                        y
                      )),
                      left: Math.round(layoutError.box.x * ratio),
                      width: Math.round(layoutError.box.width * ratio),
                      height: Math.round(Math.min(this.deviceDetails.viewport.height, layoutError.box.height) * ratio)
                    };

                    let img = `${
                      render.screenshots["full"]["screenshot"].url
                    }?tr=${tr}`;
                    let preview_img = `${
                      render.screenshots["full"]["screenshot"].url
                    }?tr=${tr_preview}`;
                    page.layoutErrors.push({
                      img: img,
                      preview: preview_img,
                      message: layoutError.text.substr(0, 120),
                      reason: layoutError.reason,
                      errorBox: errorBox
                    });
                    if (page.layoutErrors.length >= 5){
                      break;
                    }
                  }
                }
                this.pages = realPages;
              }
            }
            this.loading = false;
          },

        },

      }
    },
    computed: {
      ...mapState({activeSite: 'activeSite'}),
    },
    methods: {
      linkGen(hash) {
        if (!hash){
          hash = '';
        }
        return (pageNum) =>{
          return pageNum === 1 ? `?${hash}` : `?page=${pageNum}${hash}`
        };
      },
      mouseOver(page, index) {
        page.selectedLayoutIndex = index;
      }
    },
    mounted() {
    },
    created() {
      this.$watch(
        "$route",
        () => {
          this.loading = true;
          this.currentPage = this.$route.query.page || 1;
        },
        {
          immediate: true
        }
      );
    }
  };
</script>

<style lang="scss">
    div.errorbox{
        max-width:380px;
    }
    div.errorMessageTitle{
        max-width:400px;
        overflow:hidden;
        text-overflow:ellipsis;
    }
    div.errorMessage{
        max-width:400px;
        overflow:hidden;
        color:gray;
        padding-left:16px;
        font-size:96%;
        text-overflow:ellipsis;
    }
    div.layoutError{
        padding:4px;
    }
    div.layoutErrorActive{
        background-color: #FFCC8524;
        padding:4px;
        border-radius: 4px;
    }

</style>
